var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAuditoryCirlceCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 29.6818L122.125 35.3068L131.5 22.1818M124 4.5918C118.339 9.96738 110.801 12.9157 102.995 12.8068C102.002 15.8317 101.497 18.9956 101.5 22.1793C101.5 36.1593 111.06 47.9043 124 51.2368C136.94 47.9068 146.5 36.1618 146.5 22.1818C146.5 18.9068 145.975 15.7543 145.005 12.8043H144.625C136.635 12.8043 129.375 9.6843 124 4.5918Z",
    stroke: "#8B5CF6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuditoryCirlceCheck);
export default __webpack_public_path__ + "static/media/icon-auditory-cirlce-check.9a6d5cb6457a069cf4e3670620025c3e.svg";
export { ForwardRef as ReactComponent };